import { useMutation } from "@apollo/client";
import { gql } from "graphql-tag";
import { NotifyOscar, NotifyOscarAndJira } from "../../queries/oscar";
export const notifyOscarAndJira = gql(NotifyOscarAndJira);
export const notifyOscar = gql(NotifyOscar);
export const useNotifyFsbOscar = (envName, version) => {
    const [notifyOscarMutation] = useMutation(notifyOscar, {
        variables: {
            envName,
            version,
            category: "CMS",
            name: "Feature Service Release",
        },
    });
    return notifyOscarMutation;
};
export const useNotifyFaOscar = (name, envName, version, ticketId, transitionId, comment) => {
    const [notifyOscarMutation] = useMutation(notifyOscarAndJira, {
        variables: {
            envName,
            version,
            category: "FA",
            name,
            ticketId,
            transitionId,
            comment,
        },
    });
    return notifyOscarMutation;
};
